import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useGetReportList = () => {
  const { generalApiCall } = useGeneralApiCall();
  const getReportList = async ({ source }) => {
    try {
      const pathname = '/api/report-definition/team-report-definitions';
      const method = 'get';
      const results = await generalApiCall({
        pathname,
        method,
        needsAuthentication: true,
        requestSource: source,
        notShowErrorMessage: true,
      });
      if (results) {
        let finalResults = results.sort((a, b) => {
          return new Date(b.lastEditedAt) - new Date(a.lastEditedAt);
        });
        return finalResults;
      }
    } catch (error) {}
  };

  return { getReportList };
};

export default useGetReportList;
